import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ExamFeeProvider } from "@/context/ExamFeeContext";

import { AppRoutes } from "@/routes/AppRoutes";
import ScrollToTop from "@/components/common/ScrollToTop";

import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <ExamFeeProvider>

            {/* Scroll position reset on every route change */}
            <ScrollToTop />

            <AppRoutes />

            <Toaster
              position="top-right"
              richColors
            />

          </ExamFeeProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;